import { render, staticRenderFns } from "./CardRunStatus.vue?vue&type=template&id=726df50c&scoped=true&"
import script from "./CardRunStatus.vue?vue&type=script&lang=js&"
export * from "./CardRunStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardRunStatus.vue?vue&type=style&index=0&id=726df50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726df50c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
